export default __webpack_public_path__ + "static/media/close-icon-16px.643a3df5.svg";